import React, { useState, useEffect } from 'react';
import { FaSpinner, FaTimes } from 'react-icons/fa';
import { toast } from 'react-hot-toast';
import { ColoredPurchaseInvoiceIcon } from 'ui-component/custom-icons/icons';

// ✅ Clear
const MarkAsPurchasedModalMobile = ({ openPopup, details, onHandleReloadData, handleClose }) => {
    const [isFormDisabled, setIsFormDisabled] = useState(false);
    const [formInfo, setFormInfo] = useState({
        id: '',
        purchase_invoice_number: '',
    });

    useEffect(() => {
        setFormInfo((prev) => ({
            ...prev,
            id: details?.id,
        }));
    }, [details]);

    if (!openPopup) return null;

    const submitForm = () => {
        if (!formInfo.purchase_invoice_number) {
            toast.error('Please enter purchase invoice number');
            return;
        }
        setIsFormDisabled(true);
        if (details?.master_status?.name === 'Concept') {
            toast.promise(
                api
                    .markAsPurchased(formInfo?.id, formInfo)
                    .then((res) => {
                        setIsFormDisabled(false);
                        if (res.status) {
                            onHandleReloadData();
                        }
                        return res?.status ? res : null;
                    }),
                {
                    loading: 'Saving...',
                    success: (data) => `${data.message}`,
                    error: <b>Failed to mark as purchased</b>
                }
            );
        } else {
            toast.promise(
                api
                    .assignPurchaseInvoiceNumber(formInfo?.id, formInfo)
                    .then((res) => {
                        setIsFormDisabled(false);
                        if (res.status) {
                            onHandleReloadData();
                        }
                        return res?.status ? res : null;
                    }),
                {
                    loading: 'Saving...',
                    success: (data) => `${data.message}`,
                    error: <b>Failed to add purchase invoice number</b>
                }
            );
        }
    };

    return (
			<div
				className="d-flex"
				style={{
					width: '100vw',
					height: '100dvh',
					position: 'fixed',
					left: 0,
					top: 0,
					zIndex: 20,
					background: 'rgba(0,0,0,0.07)',
					justifyContent: 'center',
					alignItems: 'end',
					paddingBottom: '90px',
					backdropFilter: 'blur(8px)',
					WebkitBackdropFilter: 'blur(8px)'
				}}
			>
				<div
					className="popup product-popup-mobile d-md-none"
					style={{
						position: 'relative',
						transform: 'none',
						top: 0,
						left: 0,
						maxHeight: 'calc(100dvh - 110px)',
						maxWidth: '90%',
						background: '#fff',
						borderRadius: 12,
						boxShadow: 'rgb(0 0 0 / 37%) 0px 0px 20px',
						width: '100%',
						padding: '24px 16px 0 16px',
						display: 'flex',
						flexDirection: 'column'
					}}
				>
					{/* Header */}
					<div style={{ display: 'flex', alignItems: 'center', justifyContent: 'space-between', marginBottom: 12 }}>
						<div style={{ flex: 1, textAlign: 'center' }}>
							<ColoredPurchaseInvoiceIcon height={'60px'} width={'60px'} />
						</div>
					</div>

					<div style={{ textAlign: 'center', marginBottom: 12 }}>
						<div style={{ fontSize: 22, fontWeight: 600 }}>Mark as Purchased</div>
						<div className="textGray" style={{ fontSize: 14 }}>
							Add the invoice number before marking the order as purchased.
						</div>
					</div>

					<div className="form-group" style={{ marginBottom: 18 }}>
						<label className="font500">Purchase Invoice Number</label>
						<input
							type="text"
							className="form-control"
							value={formInfo?.purchase_invoice_number}
							onChange={(e) => setFormInfo({ ...formInfo, purchase_invoice_number: e.target.value })}
							placeholder="Enter purchase invoice number"
							style={{ marginTop: 4 }}
							disabled={isFormDisabled}
						/>
					</div>

					{/* Sticky bottom buttons */}
					<div
						className="btnarea"
						style={{
							position: 'sticky',
							bottom: 0,
							left: 0,
							width: '100%',
							background: '#fff',
							padding: '16px 0 12px 0',
							zIndex: 30,
							display: 'flex',
							gap: 10,
							justifyContent: 'center',
							marginTop: 'auto'
						}}
					>
						<button
							className={`btn btn-main${isFormDisabled ? ' disabled' : ''}`}
							disabled={isFormDisabled}
							onClick={() => {
								if (!isFormDisabled) {
									submitForm();
								}
							}}
						>
							{isFormDisabled ? (
								<>
									<FaSpinner className="fa-spin" /> Processing...
								</>
							) : (
								'Save'
							)}
						</button>
						<button className="btn new-btn-error" onClick={handleClose}>
							<FaTimes /> Close
						</button>
					</div>
				</div>
			</div>
		);
};

export default MarkAsPurchasedModalMobile;
